import { TaskStatus, TaskStatuses } from '../Task';
import { TaskStatus as ApiTaskStatus } from 'modules/cm/api/cases/tasks/Task';

const statusMap = new Map<TaskStatus, ApiTaskStatus>([
  [TaskStatuses.COMPLETED, 'COMPLETED'],
  [TaskStatuses.TO_DO, 'TO_DO'],
  [TaskStatuses.NOT_APPLICABLE, 'NOT_APPLICABLE'],
]);

export const mapTaskStatus = (status: TaskStatus): ApiTaskStatus => {
  return statusMap.get(status) as ApiTaskStatus;
};
